import {
  COMPANY_SET_CONFIG,
  COMPANY_SET_CONFIG_USERID,
  COMPANY_SET_CONFIG_USERNAME,
} from './actions';

const INITIAL_STATE = {
  config: null,
};

export const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case COMPANY_SET_CONFIG:
      return {
        ...state,
        config: {
          ...state.config,
          ...payload.config,
        },
      };
    case COMPANY_SET_CONFIG_USERNAME:
      return {
        ...state,
        config: {
          ...state.config,
          username: payload.username,
        },
      };
    case COMPANY_SET_CONFIG_USERID:
      return {
        ...state,
        config: {
          ...state.config,
          userid: payload.userid,
        },
      };
    default:
      return state;
  }
};
